
// v případě přístupu k obrázku podpisu ("\\\\m-halik\\sdilene\\podpis.png") - možná je nutné zvolit jinou cestu


namespace Gordic.Epk.WebControls.Vyrizeni {

    export class VyrizeniHromadneKPosouzeniEpk {

        /** důvod (upřesnění) */
        private TxtDuvod: string | null = "";
        /** ixsfun k posouzení */
        private IxsFunKPosouzeni: string = "";

        /** server method */
        private server = new GContent("Gordic.Epk.WebControls.Vyrizeni");
        /** EPK - Možnost přidat úkon Posouzení při vyřizování žádosti v EPK */
        private epk_mozpredkpos: boolean;
        /** předaný gcontent */
        private gcontent: any;
        /** pole řádků určené k vyřízení */
        private rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[];
        /** FilterPridruzenaStrediska */
        private FilterPridruzenaStrediska: boolean;
        /** FilterDlePovolenychFazi */
        private FilterDlePovolenychFazi: string[];
        /** Zašrtávátko "čekat na vyřízení" na okně K posouzení */
        private EpZaskceknavy: number;
        /** element modálního okna k posouzení */
        private modalWindowKPosouzení: JQuery<HTMLElement>;
        /** uživatelský požadavek na přerušení hromadného vyřízení */
        private userRequestedCancel: boolean = false;
        /** text uživatelského požadavku na přerušení hromadného vyřízení */
        private userRequestedCancelText: string = "jres:32000242"; //RC 32000242 : Bylo zahájeno zrušení hromadné operace.

        /** pouze ke čtení */
        private read_only: boolean = false;

        /** úspěšně vyřízené soubory */
        private success = 0;
        /** neúspěšně vyřízené soubory */
        private fail = 0;
        /** progres operace vyřízení jednoho souboru v hromadném vyřízení */
        private progress = 0;
        /** zbývající počet souborů (pro hromadné vyřízení) */
        private remainsFile = 0;
        /** index souboru, který se právě vyřizuje  */
        private indexFile = 0;

        /** hodnota checkCekatNaVyrizeni políčka */
        private checkCekatNaVyrizeni: boolean = false;

        public run(gcontent: GContent<any>, rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {

            this.gcontent = gcontent;
            this.gcontent.signing = true;			                // příznak podepsání, k posouzení, vrácení
            this.epk_mozpredkpos = this.gcontent.epk_mozpredkpos;
            this.rows = rows;

            this.server.call("getValuesKPosouzeni")
                .then((data) => {
                    this.initKPosouzeni(data);
                }, (reason) => {
                    var obj = { reason: reason.responseText, handled: false, type: EReasonType.serverError, operation: OperationsEnum.sign };
                });

        }

        private initKPosouzeni(data) {

            this.FilterPridruzenaStrediska = data.FilterPridruzenaStrediska;
            this.FilterDlePovolenychFazi = data.FilterDlePovolenychFazi;
            this.EpZaskceknavy = data.EpZaskceknavy;
            this.modalWindowKPosouzení = this.gcontent.dialogs.showModalWindow(this.createFormKPosouzeni(), null, {
                width: 900,
                height: 400,
                title: "jres:32000101",															//RC 32000101 : Předat k posouzení
                commandBar: this.createCommandbarKPosouzeni()
            });

        }

        /** vytvořit formulář k posouzení */
        private createFormKPosouzeni() {

            let form = $("<div class='form_kposouzeni_class'>");
            let Form = new Gordic.Forms.Form({
                name: "FormKPosouzeni",
            });

            Form
                .addSection()
                .addRow("jres:26265023")			//RC 26265023 : Vyřizuje
                .addField("gselectbox", (Gordic as any).Gin.Fields.ginsfunSSU({
                    name: "selectVyrizuje",
                    serverFilters: {
                        aktivita: [100],
                        DlePovolenychFazi: this.FilterDlePovolenychFazi,
                        PridruzenaStrediska: this.FilterPridruzenaStrediska
                    },
                    change: (ev, obj) => {
                        if (obj.value === null) {
                            if (this.gcontent.actions.actKPosouzeniOk !== undefined) { this.gcontent.actions.actKPosouzeniOk.update({ enabled: false }) }
                        }
                        else {
                            if (obj.value.ixs_fun !== undefined && obj.value.ixs_fun !== null) { this.IxsFunKPosouzeni = obj.value.ixs_fun; }
                            if (this.gcontent.actions.actKPosouzeniOk !== undefined) {
                                this.gcontent.actions.actKPosouzeniOk.update({ enabled: true })
                            }
                        }
                    }
                }, false))

            Form
                .addRow()
                .addField("gcheck", {
                    name: 'checkCekatNaVyrizeni',
                    label: "jres:32000102",			//RC 32000102 : Čekat na vyřízení
                    change: (ev, obj) => {

                        if (obj.value === null) {
                            obj.value = false;
                        }
                        
                        this.checkCekatNaVyrizeni = obj.value;
                    }
                })
                .addRow("jres:32000042")			//RC 32000042 : Upřesnění
                .addField("gstringbox", {
                    name: "TxtDuvod",
                    rows: 5,
                    change: (ev, obj) => {
                        this.TxtDuvod = obj.value;
                    }
                })

            form.gform("createFrom", Form);

            return form;
        }

        /** vytvořit commandbar k posouzení */
        private createCommandbarKPosouzeni() {

            var that = this;
            const menuBar: MenuParams[] = [];

            menuBar.push({
                action: this.gcontent.actions.add(new GAction({
                    name: "actKPosouzeniCancel",
                    caption: "jres:32000024",		//RC 32000024 : Zrušit
                    align: "opposite",
                    run: function (ev: any, ctx) {
                        that.userRequestedCancel = true;
                        this.content.tryCloseAllSignificants();
                        that.kPosouzeniShowResult();
                    }
                }))
            }) as MenuParams;
            menuBar.push({
                action: this.gcontent.actions.add(new GAction({
                    name: "actKPosouzeniOk",
                    enabled: false,
                    caption: "jres:32000008",		//RC 32000008 : Ok
                    align: "opposite",
                    run: function(ev: any, ctx) {
                        this.content.tryCloseAllSignificants();
                        var item = that.rows[that.indexFile];
                        that.runOperation(true, { ixp: item.ixp!, success: 0, fail: 0, remains: that.remainsFile, progressText: "jres:32000266", typ_pozad_pod: item.typ_pozad_pod! }, { total: 3, progress: that.progress });
                        that.kPosouzeniInit();
                    }
                }))
            }) as MenuParams;
            return menuBar;
        }

        /**
        * kontrola, jestli mohu předat k posouzení
        * @returns
        */
        private checkPosoudit() {

            var row = this.rows[this.indexFile];

            if ((!this.read_only && row.aktivita === 100 && !(row.ixs_spd === null || row.ixs_spd === "" || row.ixs_spd === undefined) && this.epk_mozpredkpos)) {
                return $.Deferred().resolve();
            }
            else {
                // Na této žádosti není povolen úkon "K Posouzení"
                return $.Deferred().reject({ reason: "jres:32000352", handled: false, type: EReasonType.common }).promise();
            }

        }

        /**
         * posunutí na další soubor (po vyřízení prvního) - u hromadných operací K posouzeni
         */
        private kPosouzeniShiftToVyrizNextFile() {
            // posunutí na další soubor k vyřízení
            this.indexFile++;

            // zvýšení hodnoty úspěchu (success) + 1
            // snížení počtu souborů (remains) - 1
            // RC 32000237 : Probíhá inicializace
            this.progress = 0;
            var item = this.rows[this.indexFile];
            this.runOperation(true, { ixp: item.ixp!, success: this.success++, fail: this.fail, remains: --this.remainsFile, progressText: "jres:32000266", typ_pozad_pod: item.typ_pozad_pod! }, { total: 3, progress: this.progress });

            this.kPosouzeniInit();

        }

        /**
         * k posouzení (call)
         */
        private callKPosouzení() {

            var row = this.rows[this.indexFile];

            return this.server.call("KPosouzeniOk", {
                ChkCekatNaVyrizeni: this.checkCekatNaVyrizeni,
                IxsFun: this.IxsFunKPosouzeni,
                TxtDuvod: this.TxtDuvod,
                SchUroven: row.sch_uroven,
                Ixp: row.ixp,
                IxsSpd: row.ixs_spd,
                SPri: row.s_pri
            }).then((resposne) => {
                return resposne;
            }, (reason) => {
                var responseText = handleException(reason, "KPosouzeniOk");
                return $.Deferred().reject({ reason: responseText, handled: false, type: EReasonType.serverError }).promise();
            })
        }

        private IsUserRequestedCancel(customDto?: any) {

            var dfd = $.Deferred();

            if (this.userRequestedCancel === true) {
                var obj: IGReasonResponse = {
                    reason: "jres:32000487", //RC 32000487 : Přerušeno uživatelem.
                    handled: false,
                    type: EReasonType.userCancelled,
                    operation: OperationsEnum.sign
                }
                dfd.reject(obj, true);
            }
            else {
                dfd.resolve(customDto);
            }
            return dfd.promise();
        }

		/**
		 * inicializace operace k posouzení
		 */
        private kPosouzeniInit() {

            this.checkPosoudit()
                .then(() => {
                    return this.IsUserRequestedCancel();
                })
                .then(() => {
                    return this.callKPosouzení();
                })
                .done((value: string) => {
                    // konec předchozí operace
                    this.gcontent.endOperation();
                    // zapsání úspěchu do gridu
                    this.changeStateOnGrid({ success: true });
                    // poslední soubor k vyřízení -> ukončíme hromadné vyřízení
                    if (this.indexFile === (this.rows.length - 1)) {
                        // zvýšení indexu posledního vyřízeného souboru
                        this.success++;
                        this.kPosouzeniShowResult();
                    }
                    // posuneme se na vyřízení dalšího souboru
                    else {
                        this.kPosouzeniShiftToVyrizNextFile();
                    }
                })
                .fail((reason: IGReasonResponse, userRequestCancel: boolean) => {

                    Gordic.Gui.WebApp.Utils.showReasonFlash(this.gcontent, reason);

                    // konec předchozí operace
                    this.gcontent.endOperation();
                    // uživatelské přerušení hromadného vyřízení
                    if (userRequestCancel === true) {
                        this.kPosouzeniShowResult();
                    }
                    else {

                        if (reason != null) {
                            // zapsání neúspěchu do gridu + chybová zpráva
                            this.changeStateOnGrid({ success: false, message: reason.reason });
                            this._failSingle();
                        }
                        else {
                            console.error("Při hromadném vyřízení nastala chyba.");
                            this.kPosouzeniShowResult();
                        }

                    }
                })

        }

        private _failSingle() {
            // failnutý soubor je zároveň poslední soubor k vyřízení -> ukončíme hromadné vyřízení
            if (this.indexFile === (this.rows.length - 1)) {
                // zvýšení indexu posledního nevyřízeného souboru
                this.fail++;
                this.kPosouzeniShowResult();
            }
            else {
                // thazmuka (11.03.2019) - přidání počítadla na faily, který chyběl
                this.fail++;
                this.kPosouzeniShiftToVyrizNextFile();
            }
        }

        /**
         * ukaž výsledek hromadného K Posouzení (vyhodnocení, které soubory se úspěšně/neúspěšně vyřídily a dle toho zobrazit flash)
         */
        private kPosouzeniShowResult() {
            // uživatelské přerušení hromadných operací
            if (this.userRequestedCancel) {
                this.gcontent.showFlash({
                    id: "id-flash-user-request-cancel",
                    content: "jres:32000264", //RC 32000264 : Hromadná operace K posouzení byla přerušena.
                    state: "warning"
                });
            }
            else {

                if (this.fail > 0) {
                    this.gcontent.showFlash({
                        id: "id-flash-result",
                        content: "jres:32000326", //RC 32000326 : V hromadné operaci K Posouzení se nepodačilo vyřídit některé záznamy.
                        state: "error"
                    });
                }
                else {
                    this.gcontent.showFlash({
                        id: "id-flash-result",
                        content: "jres:32000265", //RC 32000265 : Hromadná operace K posouzení byla dokončena.
                        state: "info"
                    });
                }

            }
            this.gcontent.signing = false;
        }


        /**
         * spustit operaci (gcover)
         *
         * @param {boolean} begin beginOperation (true), progressOperation(false)
         * @param {IOperationCoverValue} value hodnoty textu
         * @param {IOperationCoverCounter} counter hodnoty počítadla
         */
        private runOperation(begin: boolean, value: IOperationCoverValue, counter: IOperationCoverCounter): void {

            if (this.userRequestedCancel) {
                //#region text přerušení operace
                var text = this.userRequestedCancelText;
                //#endregion
            }
            else {
                //#region text operace
                /** text operace */
                var text = value.progressText + " - <b>" + value.ixp + "</b>" + "<br>";
                text += "<p><b style='color: green'>" + value.success + "</b>/";
                text += "<b style='color: red'>" + value.fail + "</b>";
                text += "<b> zbývá " + value.remains + " </b></p>";
                //#endregion
            }

            //#region beginOperation
            if (begin && (counter.total !== undefined)) {
                this.gcontent.beginOperation({
                    text: text,
                    total: counter.total,
                    progress: counter.progress,
                    cancelAction: new GAction({
                        name: "btnAction",
                        caption: "jres:32000024",			//RC 32000024 : Zrušit
                        run: (ev, ctx) => {
                            this.userRequestedCancel = true;
                            this.gcontent.progressOperation(this.userRequestedCancelText, this.progress);
                        }
                    })
                });
            }
            //#endregion

            //#region progressOperation
            else {
                this.gcontent.progressOperation(text, counter.progress);
            }
            //#endregion
        }

        /**
		 * změnit stav vyřízení (Success, Fail) na seznamu
		 */
        private changeStateOnGrid(state: { success: boolean, message?: string }) {
            var row = this.rows[this.indexFile];
            if (state.success) {
                row["stav"] = 0;
            }
            else {
                row["stav"] = 1;
                row["stav_zprava"] = state.message;
            }
            (this.gcontent as any).grid.ggrid("setData", this.rows);
        }


    }

    /** třída posouzení v epk */
    export class PosouzeniEpk {

		/**
		 * zahájení procesu předání "K posouzení" / "Dát na vědomí"
		 */
        public predatKPosouzeniDaniNaVedomi(cnt: GContentType<any>, rows: Gordic.Wfl.Interface.GPodpisovaKnihaDto[]) {
            return Epk.Dialogs.KPosouzeniDlg(cnt, {
                rows: rows
            }, Gordic.Global.Enums.ModOtevreni.showModalWindow);
        }

    }









    /**
     * Vyřízení v EPK
     *  [OBSOLETE]
     * @author thazmuka
     * @since 490.1.0.4
     */
    export class _VyrizeniEpk {

        constructor(cnt: GContentType<GEpkDbParamsNew>) {
            this.gcontent = cnt;
            // zapnutí / vypnutí async. vyřízení
            this.async = cnt.EpkParams.epk_asyncvyriz === 1;
        }

        //#region -- atributy --

        /** async vyřízení */
        private async: boolean;
        /** funkční místo - předání */
        private ixs_fun?: string;
        /** spisový uzel - přidělení + funkční místo  */
        private ixs_su?: string;
        private signer: Gordic.Epk.WebControls.GEpkSigner;
        /** parametry*/
        private params: IVyrizeniEpkParams;
        /** text důvodu vyřízení */
        private duvodVyrizeniTxt: string = "";
        /** předaný gcontent */
        private gcontent: GContentType<GEpkDbParamsNew>;
        /** příznak, že právě probíhá podepisování */
        private signing: boolean;
        /** deferred */
        private dfd: JQuery.Deferred<any>;
        /** id flashe */
        private idFlash = "id-flash-epk";
        //#endregion

        /**
         * spuštění vyřízení
         */
        public run(params: IVyrizeniEpkParams, row: Gordic.Wfl.Interface.GPodpisovaKnihaDto): Promise<any> {

            this.dfd = $.Deferred();
            this.params = params;
            this.signing = (this.gcontent as any).signing;
            this.gcontent.hideFlash(this.idFlash);

            // vynucené zadání důvodu při kladném vyřízení (db parametr)
            if (params.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.Povoleno)
                this.params.duvodVyrizeni = this.gcontent.EpkParams.epk_shreaspos!;

            //#region --- settlement_reason (důvod vyřízení) ---

            var settlement_reason = "";
            var keyPath = String.Format("settlementReason.{0}{1}", row.ixp!, row.ser_cislo!.toString());

            if (this.gcontent.globalSettings != null && keyPath !== "") {
                var value: string = this.gcontent.globalSettings.get(keyPath);
                settlement_reason = value == null ? "" : value.trim();
            }

            //#endregion

            if (this.params.duvodVyrizeni === true) {
                new DuvodVyrizeni().run(this.gcontent, this.params.zpusobVyrizeni, this.params.typPozadavku, settlement_reason)
                    .then((opt) => {
                        // nastavení nového důvodu vyřízení
                        this.duvodVyrizeniTxt = opt.duvod_vyrizeni;
                        if (this.params.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                            if (this.params.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Predani || this.params.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni) {
                                this.ixs_fun = opt.ixs_fun;
                                this.ixs_su = opt.ixs_su;
                            }
                        }
                        this.init(row);
                    })
                    .fail((reason: IGReasonResponse) => {
                        if (reason.handled === false) {
                            this.showFlash(reason);
                        }
                    })
            }
            else {

                // máme k dispozici uložený důvod vyřízení
                if (settlement_reason !== "") {
                    this.duvodVyrizeniTxt = settlement_reason;
                }

                this.init(row);
            }

            return this.dfd.promise();
        }

        /** 
         * Inicializace kategorie důvodu podpisu (pokud je povolena)
         * thazmuka (19.10.2021)
         * */
        public initKtgDuvodPodpis(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {

            var epkParams = this.gcontent.EpkParams;
            var dpoEnabled = epkParams.gin_sgn_ktgdp;

            if (dpoEnabled === false || row.ktg_priz_edit_text === 0)   // pokud důvod nelze editovat, přeskočím
                return null;

            var ktgDto: GKtgDpoSupportDbParamsDto = {
                gin_ele_craz_ob: epkParams.gin_ele_craz_ob,
                gin_ele_craz_pr: epkParams.gin_ele_craz_pr,
                gin_ele_pcasraz: epkParams.gin_ele_pcasraz,
                gin_ele_pdfltv: epkParams.gin_ele_pdfltv,
                gin_pdf_pictpos: epkParams.gin_pdf_pictpos,
                gin_sgn_ktgdp: dpoEnabled === true ? 1 : 0
            };

            return ktgDto;
        }

        /**
         * Inicializace podepisovacího objektu 
         * po inicializace kategorií důvodu podpisu
         * thazmuka (19.10.2021)
         * */
        private initSign(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {
            var ktgDto = this.initKtgDuvodPodpis(row);
            if (ktgDto == null)
                this.signer = new GEpkSigner({ povoleniPraceDialoguDuvoduPodpisu: false });
            else
                this.signer = new GEpkSigner({ cnt: this.gcontent, povoleniPraceDialoguDuvoduPodpisu: true, ktgDto: ktgDto, row: row });

            return this.signer;
        }

        private runOperation(id: string, begin: boolean, progress: boolean, message?: string, needsToWaitForConfirmation?: boolean) {

            //if (this.async === true)
            //    return;

            var text = message == null ? "" : message;

            if (needsToWaitForConfirmation === true) {
                text += " <br>" + "<i>jres:32000971</i>"; //RC 32000971 : Můžete být vyzváni k potvrzení podepsání na mobilu.
            }

            if (begin === true && progress === false)
                this.gcontent.beginOperation({ id: id, text: text });
            if (begin === false && progress === true)
                this.gcontent.progressOperation({ id: id, text: text });
            if (begin === false && progress === false)
                this.gcontent.endOperation({ id: id, text: text });
        }

        /** Using certificate's private key is protected by another authentication factor and thus it's needed to wait for it's confirmation*/
        private needsToWaitForConfirmation: boolean | null | undefined;

        /** init */
        private init(row: Gordic.Wfl.Interface.GPodpisovaKnihaDto) {

            var that = this;

            // INFO:

            // - typy vyřízení:
            // - pro všechny typy vyřízení budu používat nové async. serverové
            // - až na UKA variantu (pravděpodobně nefunkční)
            // - a nebo pokud použiji ne 602 certifikat nebo budu chtít využít vizuálního podpisu (zde by se dali ještě specifikovat varianty)

            /** identifikator progresu operace */
            const id = "idProgress";


            function init() {

                /** parametry */
                var params = that.params;

                //#region -- gcover && notifications --

                that.runOperation(id, true, false, "");
                const notification = new AsyncNotification();

                //#endregion

                // vráceno k přepracování
                if (params.zpusobVyrizeni === Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani) {
                    that.vyriditServer(params, id);
                    //that.vyriditBezPodepsani(notification);
                    return;
                }

                // typ požadavků s podepsáním
                if (params.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Podepsat || params.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.PodepsatASchvalit) {

                    const signer = that.initSign(row);
                    const cert = new Vyrizeni.VyberCertifikatu(signer);

                    cert
                        .select(params.ixsDpo)
                        .then((certInfo: CertInfo) => {
                            that.needsToWaitForConfirmation = cert.checkNeedsToWaitForConfirmation(certInfo);
                            return certInfo;
                        })
                        .then((certInfo: CertInfo) => {

                            var povoleneVizualUmisteni = true;
                            if (that.gcontent.EpkParams.epk_povumipod === 0 || that.gcontent.EpkParams.gin_pdf_pictpos === 0) {
                                povoleneVizualUmisteni = false;
                                console.warn("Vizuální umístění není povoleno kvůli DB parametrům - epk_povumipod === 0 || cnt.EpkParams.gin_pdf_pictpos === 0");
                            }
                            else {
                                console.info("Vizuální umístění je povoleno.");
                            }

                            if (povoleneVizualUmisteni === true || certInfo.certMoreInfo?.SgnWebServiceType !== Gordic.Security.Service.GSgnWebserviceType.S602_SecuSign) {
                                console.info("Je povoleno vizuální umístění nebo cert/pecet není typu 602 - jdu starou logikou");
                                that.vyriditSPodepsanim(certInfo, id, notification);
                                return;
                            }
                            // info: verze vyřízení s podepsáním na serveru (měla by přežít zavření WK aplikace)
                            else if (certInfo.certMoreInfo?.SgnWebServiceType === Gordic.Security.Service.GSgnWebserviceType.S602_SecuSign) {
                                that.vyriditServer(params, id, certInfo);
                                return;
                            }
                            else {
                                // UKRAJINSKÁ VARIANTA
                                if (Gordic.Wfl.WebClient.GetGWflDBParams().IsUkraine === true) {
                                    that.vyriditSPodepsanimUkr(notification, id);
                                    return;
                                }
                                else {
                                    console.error("Nebyl zvolen žádný typ vyřízení.");
                                    //notification.endOperation("error", that.params);
                                    that.signing = false;
                                    that.runOperation(id, false, false);
                                    return;
                                }
                            }

                        })
                        .fail((reason: IGReasonResponse) => {
                            Gordic.Gui.WebApp.Utils.showReasonFlash(that.gcontent, reason);
                            if (reason.handled === false) {
                                that.showFlash(reason);
                            }
                            //notification.endOperation("error", that.params, reason);
                            that.signing = false;
                            that.runOperation(id, false, false);
                            that.dfd.reject("fail");

                        })
                }
                else {
                    // vyřízení bez podepsání
                    that.vyriditServer(params, id);
                    //that.vyriditBezPodepsani(notification);
                }


            }

            // validace žádosti, jestli již neproběhlo vyřízení
            Gordic.Isl.ElectronicSignatureBookRequest.read({ rq: { data: { ixp: row.ixp, ser_cislo: row.ser_cislo } }, table: Gordic.Wfl.Interface.GPodpisovaKnihaTableEnum.WFLSZPS }).getData()
                .then((outputRow) => {
                    if (outputRow == null || outputRow.ixp == null) {
                        var obserOpt = new GObservableObject({
                            id: "idNotificationRequestIsDone",
                            title: "jres:32000803", //RC 32000803 : Žádost již byla vyřízena
                            content: "jres:32000804", //RC 32000804 : Prosím občerstvěte seznam.
                            icon: "fa-exclamation-triangle",
                            state: "warning"
                        } as IGNotificationOptions);
                        $.content().notification("add", obserOpt, true);
                    }
                    else {
                        init();
                    }
                })
                .fail((reason: IGReasonResponse) => {
                    Gordic.Gui.WebApp.Utils.showReasonFlash(that.gcontent, reason);
                    if (reason.handled === false) {
                        that.showFlash(reason);
                    }
                    that.signing = false;
                    that.runOperation(id, false, false);
                    this.dfd.reject("fail");
                })
        }




        // --------------------------------------------------------------------------------------------------------------------------
        // -- SERVER SIDE INICIALIZATION --
        // --------------------------------------------------------------------------------------------------------------------------

        /** vyřízení na serveru (602) */
        private vyriditServer(params: IVyrizeniEpkParams, id: string, certInfo?: CertInfo) {

            var opt: Wfl.Interface.GEpkCompleteConfigDto = {
                CertInfo: certInfo,
                Ixp: params.ixp,
                SerCislo: params.serCislo,
                ZpusobVyrizeni: params.zpusobVyrizeni,
                TypPozadavku: params.typPozadavku,
                VyrizeniTxt: this.duvodVyrizeniTxt == null ? "" : this.duvodVyrizeniTxt,
                IxsDpo: params.ixsDpo,
                CasRazitko: params.casoveRazitko,
                CasRazitkoPrilohy: params.casoveRazitkoPrilohy,
                PodepsatObraz: params.podepsatObraz,
                PodepsatPrilohy: params.podepsatPrilohy,
                PredPodepsanimKonvertovat: params.predPodepsanimKonvertovat,
                ZkonvertovatPrilohy: params.zkonvertovatPrilohy,
                PodepsatPrilohyNePdf: params.podepsatPrilohyNePdf,
                GuidGFRM: params.guidGFRM == null ? "" : params.guidGFRM
            };

            var list: Wfl.Interface.GEpkCompleteConfigDto[] = [];
            list.push(opt);

            // spuštění serverové vyřízení pro 602
            //new SettlementServerSide(this.gcontent, id, certInfo).run(list);
        }

        // --------------------------------------------------------------------------------------------------------------------------

        //[OBSOLETE]
        /** vyřídit bez podepsáním */
        private vyriditBezPodepsani(notification: AsyncNotification) {

            //// thazmuka (28.01.2020) - zrušení parametrů určené k podepsání, padalo na kontrolu typu pdf, která se má provádět pouze při podepsání
            //this.params.podepsatObraz = false;
            //this.params.podepsatPrilohy = false;
            //this.params.podepsatPrilohyNePdf = false;

            ///** název požadavku */
            //var name = new Vyrizeni.NazevVyrizeni().getName(this.params.zpusobVyrizeni, this.params.typPozadavku);
            //var epkConfig = new Vyrizeni.EpkConfig();

            //notification.progressOperation({ content: "jres:32000780", progress: { current: 40, total: 100 } }); //RC 32000780 : Probíhá kompletace podpisů
            //epkConfig.callEpkCompleteConfig(this.params, this.async, this.duvodVyrizeniTxt)
            //    .then((Output) => {
            //        this.GuidConfig = Output.GuidConfig;
            //        return epkConfig.sortConfigs(Output.List);
            //    })
            //    .then((configsToSign) => {

            //        // thazmuka (25.4.2022) - doplnění souborů v rámci vyřízení i u nepodepisované větve
            //        var data: EpkVyrizeniResultDto[] = [];
            //        if (configsToSign != null) {
            //            for (var x = 0; x < configsToSign.length; x++) {
            //                var config = configsToSign[x];
            //                var dto: EpkVyrizeniResultDto = { fileName: config.fileName!, guid: config.guid!, IsConverted: config.IsConverted!, IsSigned: config.IsSigned!, IxsUlo: config.IxsUlo! };
            //                data.push(dto);
            //            }
            //        }

            //        this.runOperation(false, true, "jres:32000484 " + name + "."); //RC 32000484 : Probíhá dokončení
            //        notification.progressOperation({ content: "jres:32000777", progress: { current: 80, total: 100 } }); //RC 32000777 : Probíhá dokončení vyřízení

            //        return epkConfig.callEpkFinishSettlement(this.gcontent, this.params, this.GuidConfig, data);
            //    })
            //    .then(() => {
            //        this.vyrizeniPredaniPrideleni();
            //    })
            //    .done(() => {
            //        this.signing = false;
            //        //new NotificationSender().send(this.gcontent, this.params, "success");
            //        this.runOperation(false, false);
            //        notification.endOperation("success", this.params, null);

            //        this.dfd.resolve("success");
            //    })
            //    .fail((reason: IGReasonResponse) => {
            //        Gordic.Gui.WebApp.Utils.showReasonFlash(this.gcontent, reason);
            //        if (reason.handled = false) {
            //            this.showFlash(reason);
            //        }

            //        //new NotificationSender().send(this.gcontent, this.params, "fail", reason);
            //        notification.endOperation("error", this.params, reason);

            //        this.signing = false;
            //        this.runOperation(false, false);
            //        this.dfd.reject("fail");
            //    })

        }

        private hasValue(value?: string | null) {
            if (value == null)
                return false;
            else if (value === "")
                return false;
            else
                return true;
        }

        private vyrizeniPredaniPrideleni() {

            // operace se může provádět jen při vrácení k přepracování a při zpecifických typech požadavků
            if (this.params.zpusobVyrizeni !== Gordic.Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani)
                return $.Deferred().resolve().promise();

            var dfd = $.Deferred();
            /** identifikátor dokumentu/spisu/žádosti */
            var ixp = this.params.ixp;
            /** připomínky */
            var comments = this.duvodVyrizeniTxt;

            if (this.params.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Predani) {
                if (this.hasValue(this.ixs_fun) === true) {
                    return this.server.call("Predat", { Ixp: ixp, Comments: comments, IxsFun: this.ixs_fun })
                        .then(() => {
                            new NotificationSender().sendCustom(this.gcontent, "jres:32000695"); //RC 32000695 : Cíl předání byl úspěšně změněn.
                            dfd.resolve();
                        })
                }
            }
            else if (this.params.typPozadavku === Gordic.Wfl.Interface.TypPozadavkuEpk.Prideleni) {
                if (this.hasValue(this.ixs_su) === true) {  // spisový uzel je povinný, funkční místo vyplněno být nemusí
                    this.server.call("Pridelit", { Ixp: ixp, Comments: comments, IxsFun: this.ixs_fun, IxsSu: this.ixs_su })
                        .then(() => {
                            new NotificationSender().sendCustom(this.gcontent, "jres:32000696"); //RC 32000696 : Cíl přidělení byl úspěčně změněn.
                            dfd.resolve();
                        })
                }
            }
            else {
                dfd.resolve();
            }

            // dodatečné předání, přidělení přeskočíme -> netýká se nás
            return dfd.promise();
        }

        private GuidConfig?: string | null;

        /** 
         *  Validace/vynucení časového razítka (před vyřízením) ze šablony důvodu podpisu
         *  - zjistím, jestli jsou aktivovány kategorie důvodu podpisu, dle IxsDpo načtu nastavení čas. razítka ze šablony
         *  a upravím dle toho hodnotu stavů čas. razítek
         *  thazmuka (19.8.2021)
         * */
        private validateCasRazitko() {
            var def = $.Deferred();
            new GEpkCommon().getPrizSabCasRazitko(this.gcontent, this.params.ixsDpo)
                .then((sablonaCasRazitko) => {
                    if (sablonaCasRazitko > -1) { // 0 - nastavit na NE, 1 - nastavit na ANO
                        this.params.casoveRazitko = sablonaCasRazitko === 0 ? false : true;
                        this.params.casoveRazitkoPrilohy = sablonaCasRazitko === 0 ? false : true;
                    }
                    // v ostatních případech nechám původní hodnotu danou DB parametry řízení a viditelnost, či uživ. nastavením
                    def.resolve();
                })
            return def.promise();
        }

        /** vyřídit s podepsáním */
        private vyriditSPodepsanim(certInfo: CertInfo, idNot: string, notification: AsyncNotification) {

            const ixp = this.params.ixp;
            const id = idNot + ixp;

            notification.beginOperation(ixp, id);
            notification.progressOperation(id, { content: "jres:32000776", progress: { current: 0, total: 100 } }); //RC 32000776 : Probíhá příprava vyřízení

            /** název požadavku */
            var name = new Vyrizeni.NazevVyrizeni().getName(this.params.zpusobVyrizeni, this.params.typPozadavku);
            var epkConfig = new Vyrizeni.EpkConfig();

            this.params.certInfo = certInfo;

            this.validateCasRazitko()
                .then(() => {

                    this.runOperation(idNot, false, true, "jres:32000780"); //RC 32000780 : Probíhá kompletace podpisů
                    notification.progressOperation(id, { content: "jres:32000780", progress: { current: 30, total: 100 } }, null, this.needsToWaitForConfirmation!); //RC 32000780 : Probíhá kompletace podpisů
                    return epkConfig.callEpkCompleteConfig(this.params, this.async, this.duvodVyrizeniTxt);
                })
                .then((Output) => {
                    this.GuidConfig = Output.GuidConfig;
                    return epkConfig.sortConfigs(Output.List);
                })
                .then((configsToSign) => {

                    notification.progressOperation(id, { content: "jres:32000781", progress: { current: 60, total: 100 } }, null, this.needsToWaitForConfirmation!); //RC 32000781 : Probíhá podepsání
                    this.runOperation(idNot, false, true, "jres:32000520", this.needsToWaitForConfirmation!) //RC 32000520 : Probíhá podepsání

                    // podepsání žádosti
                    var Signer = new Vyrizeni.Signer();
                    Signer.finalizeConfigDelegate(this.gcontent, this.signer, false);

                    return Signer.sign(configsToSign, {
                        casoveRazitko: this.params.casoveRazitko,
                        serCisloEpk: this.params.serCislo,
                        async: this.async                       // předáni info o async, aby se přeskočilo vizuální umístění podpisu
                    }, this.signer, this.params.certInfo!);

                })
                .then((data: EpkVyrizeniResultDto[]) => {
                    notification.progressOperation(id, { content: "jres:32000777", progress: { current: 80, total: 100 } }); //RC 32000777 : Probíhá dokončení vyřízení
                    this.runOperation(idNot, false, true, "jres:32001007 " + name) //RC 32001007 : Probíhá dokončení vyřízení
                    return epkConfig.callEpkFinishSettlement(this.gcontent, this.params, this.GuidConfig, data);
                })
                .done(() => {
                    this.signing = false;
                    //new NotificationSender().send(this.gcontent, this.params, "success");
                    notification.endOperation("success", id, this.params!, null);

                    this.runOperation(idNot, false, false);
                    this.dfd.resolve("success");
                })
                .fail((reason: IGReasonResponse) => {

                    Gordic.Gui.WebApp.Utils.showReasonFlash(this.gcontent, reason);
                    if (reason.handled === false) {
                        this.showFlash(reason);
                    }

                    notification.endOperation("error", id, this.params, reason);

                    this.signing = false;
                    this.runOperation(idNot, false, false);
                    this.dfd.reject("fail");
                })

        }

        private server = new GContent("Gordic.Epk.WebControls.Vyrizeni");

        /** vyřídit s podepsání pro ukrajinu */
        private vyriditSPodepsanimUkr(notification: AsyncNotification, id: string) {

            /** název požadavku */
            var name = new Vyrizeni.NazevVyrizeni().getName(this.params.zpusobVyrizeni, this.params.typPozadavku);
            var epkConfig = new Vyrizeni.EpkConfig();

            this.server.call("HaveDocImage", {Ixp: this.params.ixp, SerCislo: this.params.serCislo})
                .then((state: boolean) => {
                    if (state === false) {
                        return $.Deferred().reject({ reason: "jres:32000478", handled: false, type: EReasonType.serverError }).promise(); //RC 32000478 : Nejsou k dispozici žádné soubory k podepsání.
                    }
                    else {
                        return epkConfig.callEpkCompleteConfig(this.params, this.async, this.duvodVyrizeniTxt);
                    }
                })
                .then((signedConfigs: Wfl.Interface.GEpkSignConfigDto[]) => {
                    return epkConfig.sortConfigs(signedConfigs);
                })
                .then((configsToSign: any) => {
                    // podepsání žádosti
                    var Signer = new Vyrizeni.SignerUkr();
                    return Signer.sign(configsToSign, this.gcontent);
                })
                .then((data: any[]) => {
                    this.runOperation(id, false, true, "jres:32000484 " + name + "."); //RC 32000484 : Probíhá dokončení
                    return epkConfig.callEpkFinishSettlementUkr(this.gcontent, this.params, data);
                })
                .done(() => {
                    this.signing = false;
                    new NotificationSender().send(this.gcontent, this.params, "success");
                    this.runOperation(id, false, false);
                    this.dfd.resolve("success");
                })
                .fail((reason: IGReasonResponse) => {

                    Gordic.Gui.WebApp.Utils.showReasonFlash(this.gcontent, reason);

                    if (reason.handled === false) {
                        this.showFlash(reason);
                    }

                    new NotificationSender().send(this.gcontent, this.params, "fail", reason);

                    this.signing = false;
                    this.runOperation(id, false, false);
                    this.dfd.reject("fail");
                })

        }

        /**
         * ukaž flash failu
         * @param reason důvod chyby
         */
        private showFlash(reason: IGReasonResponse) {
            this.gcontent.hideFlash(this.idFlash);
            this.gcontent.showFlash({ id: this.idFlash, content: reason.reason, state: "error" });
        }

    }


}